import React from 'react';
import PropTypes from 'prop-types';
import {Modal, Image, Button} from '@learningblocks/exp-components';
import HintModalIcon from '@learningblocks/exp-constants/lib/Images/hint-modal-icon.svg';
import './style.scss';

export class HintsBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  modalOpen = () => {
    this.setState({modalOpen: true});
  };

  modalClose = () => {
    this.setState({modalOpen: false});
  };

  applyHint = () => {
    this.props.applyHint();
    this.modalClose();
  };

  renderModalContent = () => (
    <div className='hints-modal'>
      <span className='hints-modal__icon'>
        <Image src={HintModalIcon} alt='hint_icon' />
      </span>
      <h6 className='hints-modal__question'>
        Using a hint will eliminate one of your options. Are you sure you want
        to use a hint on this step?
      </h6>
      <p className='hints-modal__hintleft'>
        {this.props.hintsAllowed - this.props.hintsUsed} Hints Left.
      </p>
      <div className='hints-modal__buttons'>
        <Button className='noButton' onClick={this.modalClose}>
          No
        </Button>
        <Button className='yesButton' onClick={this.applyHint}>
          Yes
        </Button>
      </div>
    </div>
  );

  showModal = () => {
    return (
      this.state.modalOpen && this.props.hintsAllowed > this.props.hintsUsed
    );
  };

  renderModal = () => {
    return (
      this.showModal() && (
        <Modal
          isOpen={this.state.modalOpen}
          className='sm'
          contentLabel='Hints Modal'>
          {this.renderModalContent()}
        </Modal>
      )
    );
  };

  getHintsLeft = () => {
    return this.props.hintsAllowed - this.props.hintsUsed;
  };

  render() {
    if (this.props.visible) {
      return (
        <>
          <div className='hints-popup' onClick={this.modalOpen}>
            <span>
              {this.getHintsLeft()} /{this.props.hintsAllowed}
            </span>
            <span>Hints</span>
          </div>
          {this.renderModal()}
        </>
      );
    } else {
      return null;
    }
  }
}

HintsBlock.propTypes = {
  visible: PropTypes.bool,
  applyHint: PropTypes.func,
  hintsUsed: PropTypes.number,
  hintsAllowed: PropTypes.number,
};
